import { Box, Button, TableBody, TableContainer, TableHead, TableRow, TableCell, Typography, Table } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios, { AxiosResponse } from "axios";
import dayjs from "dayjs";
import { FormEvent, useEffect, useState } from "react";
import { getAttendanceReport } from "../../shared/AttendanceAPI";
import { GradeSectionComponent } from "../../shared/GradeSectionComponent";
import { AttendanceDTO, AttendanceStatusReportDTO, MaterialUITableDataItem, ViewState } from "../../shared/types";
import { getLoginId } from "../../user/UserService";

export const AttendanceReport = () => {
  console.log("In AttendanceReport");

  const loggedInUserId = getLoginId();
  // State
  const [viewState, setViewState] = useState<ViewState>(ViewState.IDLE);
  const [attendances, setAttendances] = useState<AttendanceDTO[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [studentFeeDuesData, setStudentFeeDuesData] = useState<MaterialUITableDataItem[]>();
  const [studentAttendanceReportList, setStudentAttendanceReportList] = useState<AttendanceStatusReportDTO[]>(undefined);

  const [grade, setGrade] = useState("");
  const [section, setSection] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [maxDays, setMaxDays] = useState<number>(undefined);

  useEffect(() => {
    console.log("In useEffect []");
    //This was complaining React Hook useEffect has a missing dependency: 'loadFacultyGrades'. Either include it or remove the dependency array
    console.log("Exiting useEffect []");
  }, []); //This executes only once

  //LEARNING async await
  //Why must the function containing await be marked async?
  // Because await pauses execution, and only an async function provides JavaScript with a Promise-based pause/resume context to do that without blocking the event loop.
  const getAttendances = async (event: FormEvent<HTMLFormElement>) => {
    console.log("in getStudents");

    event.preventDefault();
    //TODO clear state before api call
    let formattedMonth: number, formattedYear: number;
    if (selectedDate) {
      // Using dayjs to format the date and extract month and year
      formattedMonth = dayjs(selectedDate).month() + 1; // month() returns 0-11, so add 1
      formattedYear = dayjs(selectedDate).year();
    } else {
      alert("Invalid date");
      return;
    }
    console.log(formattedMonth + "-" + formattedYear);
    let dayOfAttendance = "";
    if (grade !== undefined && section !== undefined) {
      try {
        setViewState(ViewState.LOADING);
        let response: AxiosResponse = await getAttendanceReport({ grade: grade, section: section, month: formattedMonth.toString(), year: formattedYear.toString(), reportType: "MONTHLY" });
        const attReportData: AttendanceStatusReportDTO[] = response.data;
        setStudentAttendanceReportList(attReportData);
        console.log(attReportData)
        setViewState(ViewState.SUCCESS)

        let tMaxDays = new Date(formattedYear, formattedMonth + 1, 0).getDay();
        setMaxDays(tMaxDays);
        for (let day = 1; day <= tMaxDays; day++) {
          const date = new Date(formattedYear, formattedMonth, day);
          console.log(date.toDateString()); // Or do something with the date
        }

      } catch (error) {

        if (axios.isAxiosError(error)) {
          console.log(error?.response?.data);
          setErrorMessage(error.response?.data);
        } else {
          console.log("An unknown error occurred:", error);
          setErrorMessage("An unknown error occurred");
        }
        setViewState(ViewState.ERROR);
      }
    } else {
      alert("Invalid data");
    }
  };

  function getMaxCurrMonthDays(): number {
    let formattedMonth = dayjs(selectedDate).month(); // month() returns 0-11, so add 1
    let formattedYear = dayjs(selectedDate).year();
    let tMaxDays = new Date(formattedYear, formattedMonth + 1, 0).getDate();
    return tMaxDays;
  }

  return (
    <>
      <Box
        component="form"
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "center",
          justifyItems: "center",
          marginLeft: "5px",
          marginBottom: "5px",
          marginTop: "5px",
        }}
        onSubmit={getAttendances}
      >
        <GradeSectionComponent
          setGrade={(grade) => { setGrade(grade); }}
          setSection={(section) => setSection(section)}
          grade={grade}
          section={section}
          message={"Choose to Generate Attendance Report"}
        />
        <DatePicker
          label="Select MM/YYYY"
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)}
          views={['year', 'month']}  // Only show year and month
          sx={{
            width: "200px"
          }}
          slotProps={{
            textField: { size: "small" }, // 👈 makes it small like TextField
          }}
          format="MM-YYYY"
          disableFuture
        />
        <Button type="submit" variant="contained" color="primary" size="small" >
          Generate
        </Button>
      </Box>
      <br />

      {viewState === ViewState.LOADING && (<Typography>Loading</Typography>)}
      {viewState === ViewState.SUCCESS && studentAttendanceReportList.length === 0 && (<Typography>No attendance records available for the selected month.</Typography>)}
      {viewState === ViewState.SUCCESS && studentAttendanceReportList.length > 0 && (
        <TableContainer className="mui-table-container-style">
          <Table size="small" className="mui-table-bordered"
            sx={{
              fontSize: '0.875rem', // Reduce font size
              '& td, & th': {
                padding: '4px 8px', // Adjust padding
              },
            }}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Father Name</TableCell>
                {[...Array(getMaxCurrMonthDays())].map((_, index) => (
                  <TableCell key={index}>{index + 1}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {studentAttendanceReportList.map((student: AttendanceStatusReportDTO, index) => (
                <TableRow key={index}>
                  <TableCell>{student.name}</TableCell>
                  <TableCell>{student.fatherName}</TableCell>
                  {/* Attendance status for each day */}
                  {student.attendance.map((attendance, i) => (
                    <TableCell key={i}>{attendance.value.toString() === "NOT_RECORDED" ? "-" :
                      (attendance.value.toString() === 'ATTEND' ? 'P' : attendance.value.toString() === 'LATE' ? 'L' : 'A')}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {viewState === ViewState.ERROR && (
        <Typography>{errorMessage}</Typography>
      )}
    </>
  );
};
